import { render, staticRenderFns } from "./AllergyEditor.vue?vue&type=template&id=1c335623&scoped=true"
import script from "./AllergyEditor.vue?vue&type=script&lang=js"
export * from "./AllergyEditor.vue?vue&type=script&lang=js"
import style0 from "./AllergyEditor.vue?vue&type=style&index=0&id=1c335623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c335623",
  null
  
)

export default component.exports